//Customer booking view
import * as React from "react";
import {
  Box,
  Button,
  Typography,
  Grid,
  Card,
  Chip,
  Stack,
  Divider,
} from "@mui/material";

import DirectionsBusIcon from "@mui/icons-material/DirectionsBus";
import EastIcon from "@mui/icons-material/East";
import HorizontalNonLinearStepper from "../seatView/HorizontalNonLinearStepper";
import { formatBusScheduleLabel } from "../../services/busServices";

function Route({ item, index, containStep, setView, setItem, seatSelect }) {
  const [showSeatView, setShowSeatView] = React.useState(false);
  const [containStepView] = React.useState(containStep);

  return (
    <Card
      key={index}
      elevation={0}
      sx={{
        width: "100%",
        border: "1px solid rgba(0,0,0,0.08)",
        borderRadius: 3,
        overflow: "hidden",
        transition: "all 0.22s ease",
        "&:hover": {
          boxShadow: "0 8px 32px rgba(21,101,192,0.13)",
          borderColor: "#90CAF9",
          transform: "translateY(-2px)",
        },
      }}
    >
      {/* Blue accent bar on left */}
      <Box sx={{ display: "flex" }}>
        <Box
          sx={{
            width: 5,
            flexShrink: 0,
            background: "linear-gradient(180deg, #1565C0 0%, #0288D1 100%)",
          }}
        />

        <Box sx={{ flex: 1, p: { xs: 2.5, md: 3 } }}>
          {/* Header: bus number + type chips */}
          <Stack
            direction="row"
            alignItems="center"
            flexWrap="wrap"
            spacing={1}
            sx={{ mb: 2.5 }}
          >
            <DirectionsBusIcon sx={{ color: "#1565C0", fontSize: 20 }} />
            <Typography variant="subtitle1" fontWeight={800} color="#0D1B2A">
              {item.bus_number}
            </Typography>
            <Chip
              label={item.bus_type}
              size="small"
              sx={{
                bgcolor: "#E3F2FD",
                color: "#1565C0",
                fontWeight: 700,
                fontSize: "0.72rem",
              }}
            />
            <Chip
              label={`Layout: ${item?.structure?.name ?? item?.structure?.layout ?? "Custom"}`}
              size="small"
              sx={{
                bgcolor: "#F1F5F9",
                color: "#64748B",
                fontSize: "0.72rem",
              }}
            />
          </Stack>

          {/* Journey info row */}
          <Grid container alignItems="center" spacing={2}>
            {/* Departure */}
            <Grid item xs={4} md={3}>
              <Typography
                variant="h4"
                fontWeight={900}
                color="#0D1B2A"
                lineHeight={1}
              >
                {item.depature_time}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                fontWeight={600}
                mt={0.5}
              >
                {item.depature_from}
              </Typography>
            </Grid>

            {/* Journey line */}
            <Grid item xs={4} md={4}>
              <Box sx={{ position: "relative", textAlign: "center" }}>
                <Divider
                  sx={{
                    borderStyle: "dashed",
                    borderColor: "#90CAF9",
                    "&::before, &::after": { borderTop: "1.5px dashed #90CAF9" },
                  }}
                >
                  <EastIcon sx={{ color: "#1565C0", fontSize: 22 }} />
                </Divider>
                <Typography
                  variant="caption"
                  color="text.disabled"
                  sx={{ mt: 0.5, display: "block", fontWeight: 600 }}
                >
                  {formatBusScheduleLabel(item)}
                </Typography>
              </Box>
            </Grid>

            {/* Arrival */}
            <Grid item xs={4} md={3}>
              <Typography
                variant="h4"
                fontWeight={900}
                color="#0D1B2A"
                lineHeight={1}
                textAlign={{ xs: "right", md: "right" }}
              >
                {item.arrival_time}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                fontWeight={600}
                textAlign={{ xs: "right", md: "right" }}
                mt={0.5}
              >
                {item.arrival_to}
              </Typography>
            </Grid>

            {/* Price + CTA */}
            <Grid item xs={12} md={2}>
              <Box
                sx={{
                  textAlign: { xs: "left", md: "right" },
                  borderTop: { xs: "1px solid rgba(0,0,0,0.06)", md: "none" },
                  pt: { xs: 2, md: 0 },
                }}
              >
                <Typography
                  variant="h5"
                  fontWeight={900}
                  sx={{ color: "#1565C0" }}
                >
                  Rs {item.fee}
                </Typography>
                <Typography
                  variant="caption"
                  color="text.disabled"
                  display="block"
                  mb={1}
                >
                  per seat
                </Typography>
                {!seatSelect && (
                  <Button
                    onClick={() => {
                      setView("seatView");
                      setItem({
                        ...item,
                        structure: item.structure ?? item.seat_structure,
                        seat_map:
                          item.seat_map ??
                          item.structure?.seat_map ??
                          item.seat_structure?.seat_map,
                      });
                    }}
                    variant="contained"
                    size="medium"
                    sx={{
                      borderRadius: 8,
                      fontWeight: 700,
                      background:
                        "linear-gradient(135deg, #1565C0 0%, #0288D1 100%)",
                      boxShadow: "0 4px 14px rgba(21,101,192,0.35)",
                      "&:hover": {
                        boxShadow: "0 6px 20px rgba(21,101,192,0.5)",
                        transform: "translateY(-1px)",
                      },
                      transition: "all 0.2s ease",
                    }}
                  >
                    Select Seat
                  </Button>
                )}
              </Box>
            </Grid>
          </Grid>

          {containStepView && showSeatView && (
            <HorizontalNonLinearStepper item={item} />
          )}
        </Box>
      </Box>
    </Card>
  );
}

export default Route;
